import React from "react";
import {NavLink} from "react-router-dom";
import {Box, IconButton} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import {useTheme} from "@mui/material/styles";
import {useHome} from "../../context/HomeProvider";
import {useSidebarLayout} from "./Context/SidebarProvider";
import {useSidebarContentStyles} from "./sidebarStyles";
import {shield, shieldLight} from "../../resources/environment";
import logoDark from "~/src/assets/logo-dark.png";

const SidebarLogo = () => {
  const {isSidebarExpanded, toggleSidebar, xsScreen} = useSidebarLayout();
  const {classes} = useSidebarContentStyles({isSidebarExpanded});
  const theme = useTheme();
  const {home} = useHome();

  const shieldLogo = theme.palette.themeName === "light" ? shield : shieldLight;

  return (
    <Box className={classes.headerBox}>
      {isSidebarExpanded ?
        (
          <>
            <NavLink to={home} aria-label="BreachRx home">
              <img
                src={theme.palette.themeName === "breachrx" ? logoDark : theme.palette.logo}
                alt="BreachRx"
                style={{height: 24, objectFit: "contain"}}
              />
            </NavLink>
            <IconButton
              onClick={toggleSidebar}
              aria-label="Collapse sidebar"
              size="small"
              className={classes.headerIconButton}
            >
              <MenuOpenIcon />
            </IconButton>
          </>
        ) :
        (
          <IconButton
            onClick={toggleSidebar}
            aria-label={xsScreen ? "Hide sidebar" : "Expand sidebar"}
            size="small"
            className={classes.headerIconButton}
          >
            <img
              src={shieldLogo}
              alt="BreachRx"
              className="sidebar-logo-shield"
              style={{height: 24}}
            />
            <MenuIcon className="sidebar-logo-menu" />
          </IconButton>
        )}
    </Box>
  );
};

export default SidebarLogo;
